import BillItemIcon from '@material-ui/icons/ViewList';

import BillItemList from './BillItemList';

export default {
    list: BillItemList,
    icon: BillItemIcon,
};
